import { createRouter, createWebHistory } from 'vue-router';
import Layout from "@/views/layout/index.vue";
import introduce from "@/views/introduce/index.vue";
import home from '@/views/home/index.vue'
import product from "@/views/product/index.vue"
import agency from "@/views/agency/index.vue"
import experience from "@/views/experience/experience.vue"

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: home
      },
      {
        path: 'introduce',
        component: introduce
      },
      {
        path: 'product',
        component: product
      },
      {
        path: 'agency',
        component: agency
      },
      {
        path: 'experience',
        component: experience
      }
    ]
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
    